const config = {
   BASE_URL_IP: "https://nitttrc.edu.in:8095/workorder"
  //BASE_URL_IP: "localhost:8095/workorder"
  };
  
  export default config;